import { PROTOCOL_RESOURCE } from '../api/resources';
import { createResourceSlice } from '../store/resource/createResourceSlice';

const protocolsSlice = createResourceSlice({
    resource: PROTOCOL_RESOURCE,
});

export const {
    indexFulfilled,
    showFulfilled,
    storeFulfilled,
    updateFulfilled,
    destroyFulfilled,

    indexProtocols,
    showProtocol,
    storeProtocol,
    updateProtocol,
    archiveProtocol,
    restoreProtocol,
    destroyProtocol,
} = protocolsSlice.actions;

export const {
    selectProtocolById,
    makeProtocolsByIdsSelector,
    selectAllProtocolIds,
    selectAllProtocols,
    selectProtocolsLoading,
    selectProtocolsInitialized,
    selectProtocolLoading,
    selectProtocolInitialized,
} = protocolsSlice.selectors;

export const { useProtocols, useProtocol } = protocolsSlice.hooks;

export default protocolsSlice.reducer;
